const constants = {
  STOP_FIELDS_TO_TRANSFORM_LIST: [
    "plannedArrivalTime",
    "plannedDepartureTime",
    "actualArrivalTime",
    "actualDepartureTime",
  ],
  ROUTE_FIELDS_TO_TRANSFORM_LIST: [
    "driverDispatchTime",
    "gateInTime",
    "gateOutTime",
    "estimatedEmptyTime",
    "routeStartTime",
    "dispatchCancelTime",
    "terminalGeofenceExitTime",
    "terminalGeofenceEntryTime"
  ],
  STATIC_DATE_RANGE_LIST: [
    { label: "30 days", value: 30 },
    { label: "45 days", value: 45 },
    { label: "60 days", value: 60 },
  ],
};

export default constants;
